import { TV_API_URL } from '../../comm/config';
import { rewriteOBJ } from '../commlogic';
const API_HOST = TV_API_URL;

const POST_LIST = {
  postRobotRegister: '/robot/register',
  postUpdateRobot: '/robot/update',
  postDisconnectRobot: '/robot/disconnect',
  postAddServiceHours: '/serviceHour/add',
  postRemoveServiceHours: '/serviceHour/remove',
  postUpdateServiceHours: '/serviceHour/update',
  postAddUpdateQuotaSetting: '/setting/quota/update',
  updateTimeslotStatus: '/timeslot/status/update',
  reserveAvailableTimeslot: '/timeslotBooking/reserve',
  reserveUnavailableTimeslot: '/timeslot/reuse',
  cancelBooking: '/timeslotBooking/cancel',
  resendSms: '/timeslotBooking/resendSms',
  updateBooking: '/timeslotBooking/update',
  saveTelevisitMapping: '/televisitMapping/save',
  sendDelaySms: '/timeslotBooking/delay',
  addAdHocServiceHrAndReserveAvailableTimeslot: '/timeslotAdHocBooking/reserve',
  validateTimeslotBooking: '/timeslotBooking/validate',
  serviceSupportUpdateBookingStatus: '/timeslotBooking/serviceSupport/updateBookingStatus',
};
const GET_LIST = {
  getRobotList: '/robot/list',
  getRobotListAll: '/robot/listAll',
  getServiceHoursList: '/serviceHour/list',
  getTimeslotBookingList: '/timeslotBooking/list',
  getServiceHoursDetail: '/serviceHour/detail',
  getTimeslotDetail: '/timeslotBooking/detail',
  getQuotaSetting: '/setting/quota',
  getTimeslotSearch: '/timeslotBooking/search',
  getTimeslotLatestList: '/timeslot/latest/list',
  getStaticDataList: '/staticData/list',
  getPatient: '/patient/list',
  getTelevisitMappingList: '/televisitMapping/list',
  startMeetingManually: '/timeslotBooking/startMeetingManually',
  getNotificationList: '/timeslotBooking/Sms/list',
};
const TELEVISITAPI = {
  POST: POST_LIST,
  GET: GET_LIST,
};
rewriteOBJ(TELEVISITAPI, API_HOST);

export default { ...TELEVISITAPI.GET, ...TELEVISITAPI.POST };
